export const AssetSortOptions = [
  { name: "Latest", value: "id desc" },
  { name: "Oldest", value: "id asc" },
  { name: "A-Z", value: "name asc" },
  { name: "Z-A", value: "name desc" },
];
